import { IssueAreaType, IssueOptions } from '../../types/state/issues';

type BuildIssueIdParams = {
  type: IssueOptions;
  field?: string;
} & IssueAreaType;

/**
 * Constructs a unique issue identifier.
 *
 * @param params - An object containing parameters to build the issue ID.
 * @param params.area - The area of the issue ('quote', 'quoteLine', 'quotePrice', or 'snapOperation').
 * @param params.quoteLineUuid - The unique identifier for the quote line, required if area is 'quoteLine' or 'quotePrice'.
 * @param params.quotePriceUuid - The unique identifier for the quote price, required if area is 'quotePrice'.
 * @param params.snapOperationUuid - The unique identifier for the snap operation, required if area is 'snapOperation'.
 * @param params.field - An optional field to include in the ID.
 * @param params.type - The type of the issue.
 * @returns A string representing the constructed issue ID.
 */
export function buildIssueId(params: BuildIssueIdParams) {
  let id: string = params.area;

  if (params.area !== 'quote') {
    id = `${id}.${params.quoteLineUuid}`;
  }

  if (params.area === 'quotePrice') {
    id = `${id}.${params.quotePriceUuid}`;
  }

  if (params.area === 'snapOperation' || params.area === 'snapRequirement') {
    id = `${id}.${params.snapOperationUuid}`;
  }

  if (params.area === 'snapRequirement') {
    id = `${id}.${params.snapRequirementUuid}`;
  }

  if (params.field) {
    id = `${id}.${params.field}`;
  }

  return `${id}:${params.type}`;
}
